var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 0H9.41205C9.11001 0 8.86517 0.244836 8.86517 0.546875C8.86517 0.848914 9.11001 1.09375 9.41205 1.09375H12.1328L7.74906 5.47755C7.53547 5.69114 7.53547 6.03739 7.74906 6.25095C7.96261 6.4645 8.30886 6.46453 8.52245 6.25095L12.9062 1.86714V4.58793C12.9062 4.88996 13.1511 5.1348 13.4531 5.1348C13.7552 5.1348 14 4.88996 14 4.58793V0.546875C14 0.249238 13.7581 0 13.4531 0ZM6.25095 7.74906C6.03736 7.5355 5.69111 7.53547 5.47755 7.74906L1.09375 12.1329V9.41207C1.09375 9.11004 0.848914 8.8652 0.546875 8.8652C0.244836 8.8652 0 9.11004 0 9.41207V13.4531C0 13.7502 0.242074 14 0.546875 14H4.58795C4.88999 14 5.13483 13.7552 5.13483 13.4531C5.13483 13.1511 4.88999 12.9062 4.58795 12.9062H1.86714L6.25095 8.52245C6.46453 8.30886 6.46453 7.96261 6.25095 7.74906Z",
    fill: "#00346B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.bcf2f72e5bea972d8cc4e5f3ea52f60c.svg";
export { ForwardRef as ReactComponent };